import { useState, useContext } from "react";
import { DefaultContext } from "../../context/context_default";

export function useCardBuildHook() {

    const {
        is_descktop,
    } = useContext(DefaultContext);

    const [isOpenDeck, setIsOpenDeck] = useState(true)

    const toggleDrawerDeck = (value) => {
        setIsOpenDeck(value)
    }

    return {
        isOpenDeck,
        toggleDrawerDeck,
        is_descktop
    };
}